import { Directive, HostListener, inject, input } from '@angular/core';
import { AnalyticsService } from '../analytics.service';
import { ButtonClickEvent, ButtonTypeValues } from '../analytics.models';

@Directive({
  selector: 'button[appTrackedButton]',
})
export class TrackedButtonDirective {
  trackId = input.required<string>();
  trackType = input<ButtonTypeValues>('other');

  private readonly analyticsService = inject(AnalyticsService);

  @HostListener('click')
  onClick(): void {
    const properties: ButtonClickEvent = {
      buttonId: this.trackId(),
      buttonName: this.trackId(),
      buttonType: this.trackType(),
    };

    this.analyticsService.trackButtonClick(properties);
  }
}
